import React, { FC } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Divider from '../../../../BaseComponents/Divider'
import CaptionFont from '../../../../Theme/Fonts/Caption'
import { TestID } from '../../../../utils/PropTypesDefinitions'

export type SummaryEventRowBreakProps = {
    /**
     * label to be displayed in the center (e.g. time, aka match minute)
     */
    timeLabel: string
} & TestID

const SummaryEventRowBreak: FC<SummaryEventRowBreakProps> = ({ timeLabel, testID }) => (
    <Grid testID={testID} noExpand horizontal centerVertical backgroundColor="pearl">
        <Grid>
            <Divider dark />
        </Grid>
        <Grid
            noExpand
            width={40}
            height={24}
            centerVertical
            centerHorizontal
            backgroundColor="tahitian-4"
            marginX={4}
        >
            <CaptionFont color="keshi-3">{timeLabel}</CaptionFont>
        </Grid>
        <Grid>
            <Divider dark />
        </Grid>
    </Grid>
)

export default SummaryEventRowBreak
